import { Action } from 'redux'

export interface ErrorAction extends Action {
    error?: any
}

export const buildErrorAction = (type: string, error?: any): ErrorAction => ({
    type,
    error,
})